/* eslint-disable no-shadow */
import { Action } from '@reduxjs/toolkit';
import { path } from 'ramda';
import { StateObservable } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import {
  map, switchMap, first, filter, catchError,
} from 'rxjs/operators';

import { menuActions } from '../../actions';
import { RootState } from '../../types';
import { openResponsibleGaming } from './utils';

const { responsibleGaming } = menuActions;

export default function responsibleGamingEpic(action$: Observable<Action>, state$: StateObservable<RootState>) {
  return action$.pipe(
    filter(responsibleGaming.request.match),
    switchMap(() => state$.pipe(
      first(),
      filter((obj: any): obj is RootState => path([ 'config', 'widgets', 'responsibleGaming' ], obj))
    )),
    switchMap(({ config: { authParams }, user }) => from(
      openResponsibleGaming({
        user,
        authParams,
      })
    ).pipe(
      map((ok) => ({ ok })),
      catchError((e) => of({ ok: false, message: e.message }))
    )),
    map(({ ok, message }: any) => (ok ? responsibleGaming.success() : responsibleGaming.failure({ message })))
  );
}
